//imported React dependency
import React from "react"
//imported icons
import { FaCode, FaSketch } from "react-icons/fa"

export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web development",
    text: `I can build out the website of your dreams, whether you choose to bring me your own wireframed design or you want me to start from scratch.`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "web design",
    text: `Need your vision to come to life? I can help wireframe a design to fit your wants.`,
  },
]
